// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"PointsPackSection_imageContainer__KCjZC","link":"PointsPackSection_link__uB31s"};